/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import Links from '../containers/Links/Links';
import Footer from '../containers/Footer/Footer';
  
const Insta = () => {
  return (
    <div>
      <Links/>
      <Footer />
    </div>
  );
};
  
export default Insta;